import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ count, page, pageSize, onPageChange, onPageSizeChange }) {
  const pages = Math.max(1, Math.ceil(count / pageSize));
  if (!count) return null;
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, count);

  return <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-zinc-200 pt-5">
    <p className="text-xs font-bold text-zinc-500">Mostrando {first}-{last} de {count}</p>
    <div className="flex items-center gap-2">
      <label className="text-xs font-bold text-zinc-500">Filas <select aria-label="Filas por pagina" className="ml-2 rounded-lg border border-zinc-300 bg-white px-3 py-2 text-zinc-900" value={pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))}><option value={20}>20</option><option value={50}>50</option></select></label>
      <button type="button" aria-label="Pagina anterior" title="Pagina anterior" disabled={page <= 1} onClick={() => onPageChange(page - 1)} className="grid h-10 w-10 place-items-center rounded-lg bg-zinc-950 text-white disabled:cursor-not-allowed disabled:opacity-30"><ChevronLeft size={18}/></button>
      <span className="min-w-24 text-center text-xs font-black uppercase">{page} de {pages}</span>
      <button type="button" aria-label="Pagina siguiente" title="Pagina siguiente" disabled={page >= pages} onClick={() => onPageChange(page + 1)} className="grid h-10 w-10 place-items-center rounded-lg bg-zinc-950 text-white disabled:cursor-not-allowed disabled:opacity-30"><ChevronRight size={18}/></button>
    </div>
  </div>;
}


